import React from 'react';
import { Image, ImageStyle } from 'react-native';

import { makeStyles } from '@providers/Theme';

type LogoProps = {
  height: number;
  testID?: string;
};

type LogoStyleProps = {
  height: number;
  width: number;
};

const useStyles = makeStyles<LogoStyleProps>(() => ({
  root: (props) => ({
    width: props.width,
    height: props.height,
  }),
}));

export const Logo: React.FC<LogoProps> = ({ height, testID }) => {
  const aspectRatio = 1;
  const width = height * aspectRatio;

  const styles = useStyles({ height, width });

  return (
    <Image
      source={require('./assets/logo.png')}
      style={styles.root as ImageStyle}
      testID={testID}
    />
  );
};
